import { APICore } from './apiCore'

const api = new APICore()

function getUsersInfotools (params) {
  const baseUrl = '/users-infotools'
  return api.get(baseUrl, params)
}

function getUserInfotools (id) {
  const baseUrl = `/users-infotools/${id}`
  return api.get(baseUrl, {})
}

function addUserInfotools (params) {
  const baseUrl = '/users-infotools'
  return api.createWithFile(baseUrl, params)
}

function updateUserInfotools (params) {
  const baseUrl = '/users-infotools'
  return api.updateWithFile(baseUrl, params)
}

function deleteUserInfotools (params) {
  const baseUrl = '/users-infotools'
  return api.delete(baseUrl, params)
}

export { getUsersInfotools, getUserInfotools, addUserInfotools, updateUserInfotools, deleteUserInfotools }
